module.exports = __webpack_public_path__ + "img/medfilm-logo.df36542.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/logo/medfilm-logo.svg
// module id = 593
// module chunks = 30